import styled from 'styled-components/macro';

const CardStubWrapper = styled.div`
  width: 185px;
  padding-top: 10px;
  margin-bottom: 15px;
`;

export default CardStubWrapper;
